import { createAPI } from '@common'
export default {
  // 获取稿签范围初始化列表
  getLogTypes: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0mpht0uzqft', 'GET', config)
}
